import { Eye, Volume2, Brain, Activity, Heart } from 'lucide-react';

// Single source of truth for the app categories, shared by the logged-out
// Landing page (rendered as cards) and the Dashboard (rendered as filter
// chips). Change a label/icon/colour here and BOTH surfaces update together.
//
// `key` must match the `category` value used on each app in appConfig.js.
const categories = [
  { key: 'visual', label: 'Visual', icon: Eye, color: '#A8DADC' },
  { key: 'auditory', label: 'Auditory', icon: Volume2, color: '#CDB4DB' },
  { key: 'cognitive', label: 'Cognitive', icon: Brain, color: '#FFC8DD' },
  { key: 'active', label: 'Active', icon: Activity, color: '#B9FBC0' },
  { key: 'breathing', label: 'Breathing', icon: Heart, color: '#FFD6A5' },
];

export default categories;
